function SetParentHRef(element, isHugendubelImage) {
    var elementDataDetail = $(element).data('detail');
    if (typeof elementDataDetail !== 'undefined' && elementDataDetail === true) {
        $(element).parent('a').attr('HRef', $(element).attr('src'));
        var _ = GLightbox({});
        if (isHugendubelImage === true) {
            $('#ImageSourceHugendubelWrapper').show();
            $("div[id*='ImageSourceWrapper']").hide();
        } else {
            $('#ImageSourceHugendubelWrapper').hide();
            $("div[id*='ImageSourceWrapper']").show();
        }
    }
}

function LoadMissingCoverMediaGroupImage(element) {
    element.attr('src', element.attr('data-mediagroup-src'))
        .on('load', function (event) {
            event.stopPropagation();
            SetParentHRef(element, false);
        })
        .on('error', function (event) {
            event.stopPropagation();
            element.attr('src', element.attr('data-fallback-src'))
                .on('load',
                    function (event) {
                        event.stopPropagation();
                        SetParentHRef(element, false);
                    })
                .on('error',
                    function (event) {
                        event.stopPropagation();
                        element.unbind();
                    });
        });
}

function CheckSize(element) {
    var elementNaturalWidth = element.get(0).naturalWidth;
    if (elementNaturalWidth < 10) {
        return true;
    }
    return false;
}

function LoadMissingCoverReplacement(element) {
    var hgConfigured = element.data('hg-configured') === true;
    if (hgConfigured === true) {
        var hgCoverUrl = element.data('hg-src');
        if (hgCoverUrl === '') {
            LoadMissingCoverMediaGroupImage(element);
        }
        element.unbind();
        element.attr('src', hgCoverUrl)
            .on('load',
                function (event) {
                    event.stopPropagation();
                    SetParentHRef(element, true);
                })
            .on('error', function (event) {
                event.stopPropagation();
                LoadMissingCoverMediaGroupImage(element);
            });
    } else {
        LoadMissingCoverMediaGroupImage(element);
    }
}

function imageLoaded(image) {
    return new Promise(function (resolve, reject) {
        if (image.complete) {
            resolve();
        }
        function unbind() {
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', rejected);
        }
        var loaded = function () { unbind(); resolve(); };
        var rejected = function () { unbind(); reject(); };
        image.addEventListener('load', loaded);
        image.addEventListener('error', rejected);
    });
}

function LazyLoadCovers() {
    $('.thumbCoverImage').Lazy({
        threshold: 180,
        bind: event,
        visibleOnly: true,
        onError: function (element) {
            LoadMissingCoverReplacement(element, false);
        },
        afterLoad: function (element) {
            imageLoaded(element[0]).then(function () {
                if (CheckSize(element)) {
                    LoadMissingCoverReplacement(element, true);
                } else {
                    SetParentHRef(element, false);
                }
            });
        }
    });

    $('.thumbCoverImageEager').Lazy({
        delay: 50,
        onError: function (element) {
            LoadMissingCoverReplacement(element, false);
        },
        afterLoad: function (element) {
            imageLoaded(element[0]).then(function () {
                if (CheckSize(element)) {
                    LoadMissingCoverReplacement(element, true);
                } else {
                    SetParentHRef(element, false);
                }
            });
        }
    });
}

$(document).ready(function () {
    LazyLoadCovers();

    $('.divDetailCoverImage').each(function() {
        $(this).on('mouseenter',
            function () {
                $(this).find('img').addClass('coverimageopacity');
                $(this).css("background-image", "url(" + magnifierUrl + ")");
                $(this).css("background-repeat", "no-repeat");
                $(this).css("background-position", "center");
            });

        $(this).on('mouseleave',
            function () {
                $(this).find('img').removeClass('coverimageopacity');
                $(this).css("background-image", "");
                $(this).css("background-repeat", "");
                $(this).css("background-position", "");
            });
    });
});